import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ClinicLocationWithAnalytics } from '../../../common/model/dto/clinic-location';
import { useClinicLocationListColumns } from '../../../hooks/use-clinic-location-list-columns';
import { useListNavigationState } from '../../../hooks/use-list-navigation-state';
import OvRecordList from './OvRecordList';

interface OvClinicLocationListProps {
  clinicId: string;
  clinicLocations: ClinicLocationWithAnalytics[];
}

const OvClinicLocationList: FC<OvClinicLocationListProps> = ({
  clinicId,
  clinicLocations,
}) => {
  const { t } = useTranslation();
  const getNavigationState = useListNavigationState();
  const columns = useClinicLocationListColumns(getNavigationState);

  return (
    <OvRecordList
      label={t('clinicDetails.tabs.clinicSites')}
      records={clinicLocations}
      columns={columns}
      getKey={(location) => location.id}
      getDetailsPath={(location) =>
        `/clinics/${clinicId}/clinic-info/${location.id}`
      }
      getNavigationState={getNavigationState}
    />
  );
};

export default OvClinicLocationList;
